import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BadgeModule } from 'primeng/badge';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { ImageModule } from 'primeng/image';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { KeyFilterModule } from 'primeng/keyfilter';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PickListModule } from 'primeng/picklist';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollerModule } from 'primeng/scroller';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { StepperModule } from 'primeng/stepper';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { TreeSelectModule } from 'primeng/treeselect';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StyleClassModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    KeyFilterModule,
    DropdownModule,
    AutoCompleteModule,
    PanelModule,
    TableModule,
    PaginatorModule,
    TooltipModule,
    BadgeModule,
    TagModule,
    CalendarModule,
    PickListModule,
    PanelModule,
    FileUploadModule,
    ScrollerModule,
    ScrollPanelModule,
    ConfirmDialogModule,
    ButtonModule,
    MenuModule,
    CheckboxModule,
    RadioButtonModule,
    SkeletonModule,
    ImageModule,
    StepperModule,
    TabViewModule,
    SelectButtonModule,
    PanelMenuModule,
    DialogModule,
    EditorModule,
    MultiSelectModule,
    BreadcrumbModule,
    ChipModule,
    TreeSelectModule,
    MessagesModule,
    MessageModule,
  ],
  exports: [
    StyleClassModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    KeyFilterModule,
    DropdownModule,
    AutoCompleteModule,
    PanelModule,
    TableModule,
    PaginatorModule,
    TooltipModule,
    BadgeModule,
    TagModule,
    CalendarModule,
    PickListModule,
    PanelModule,
    FileUploadModule,
    ScrollerModule,
    ScrollPanelModule,
    ConfirmDialogModule,
    ButtonModule,
    MenuModule,
    CheckboxModule,
    RadioButtonModule,
    SkeletonModule,
    ImageModule,
    StepperModule,
    TabViewModule,
    SelectButtonModule,
    PanelMenuModule,
    DialogModule,
    EditorModule,
    MultiSelectModule,
    BreadcrumbModule,
    ChipModule,
    TreeSelectModule,
    MessagesModule,
    MessageModule,
  ],
})
export class PrimengModule {}
